// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2k4-R","spin":"Spinner_spin__39K9K"};